import { isPlatformServer } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  inject,
} from '@angular/core';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { ScreenSizes } from '../../../classes/screen-sizes.class';
import { sleep } from '../../../lib/sleep';
import { PICFLOW_STORYBLOK } from '../../../picflow-storyblok';
import { StoryblokComponentInstance } from '../../../services/storyblok.service';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';

@Component({
  selector: 'app-home-teaser',
  templateUrl: './home-teaser.component.html',
  styleUrls: ['./home-teaser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, DynamicComponent, DynamicIoDirective, StoryblokCdnPipe],
  providers: [StoryblokCdnPipe],
})
export class HomeTeaserComponent implements OnInit {
  @ViewChild('videoEl') videoEl: ElementRef<HTMLVideoElement>;
  @Input() _editable: string;
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() video: StoryblokImage;
  @Input() mobileVideo: StoryblokImage;
  @Input() width: number;
  @Input() height: number;
  @Input() poster: StoryblokImage;
  @Input() content: StoryblokComponentInstance[];
  private storyblokService = inject(PICFLOW_STORYBLOK);
  private cdnPipe = inject(StoryblokCdnPipe);
  components = this.storyblokService.components;

  videoPoster =
    'https://i.vimeocdn.com/video/1721334436-e911775ce8e81a272add22ba88cb0216ba70aec17e5281527195f5fbe9879db6-d?mw=2300&mh=1533&q=70';
  videoDesktop =
    'https://player.vimeo.com/external/655852217.hd.mp4?s=5a0312c4984542c18992feaa4ab07ceafc449cb0&profile_id=169';

  private platformId = inject(PLATFORM_ID);

  async ngOnInit() {
    if (isPlatformServer(this.platformId)) return;
    await sleep(0);
    if (this.videoEl) {
      const isMobile = ScreenSizes.screenSize() === 'mobile';
      let src = this.video?.filename || this.videoDesktop;
      if (isMobile && this.mobileVideo?.filename) src = this.mobileVideo?.filename;

      this.videoEl.nativeElement.src = this.cdnPipe.transform(src);

      this.videoEl.nativeElement.muted = true;
      try {
        await this.videoEl.nativeElement.play();
      } catch (e) {
        console.error(e);
      }
    }
  }
}
